import { Injectable } from "@angular/core";
import { ConfirmationContactResponse, PaymentAgreement, SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { AgreementContactResponse } from "@edp-models/edp-payment.model";
import { BehaviorSubject, Subject } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: "root",
})
export class EdpPaymentAgreementService {
    private selectedComponentSubject = new BehaviorSubject<string>(SelectedComponentEnum.PERSONAL);
    private contactResponse = new BehaviorSubject<AgreementContactResponse>(null);
    private showBottomBar = new BehaviorSubject<boolean>(false);
    private accountId = new BehaviorSubject<string>("");
    public paymentAgreementTerm = new BehaviorSubject<PaymentAgreement>(null);
    private errorProccessSubject = new BehaviorSubject<boolean>(false);
    private errorProccessToShowSubject = new BehaviorSubject<boolean>(false);
    private confirmationContactResponseSubject = new BehaviorSubject<ConfirmationContactResponse>(null);
    private ineligibleClient = new BehaviorSubject<boolean>(false);
    private killWaitingVerification = new Subject<void>();
    private heightSubject = new BehaviorSubject<boolean>(null);

    constructor(private apiService: ApiService) {}

    public killWaitingVerificationTrigger$ = this.killWaitingVerification.asObservable();

    onKillWaitingVerification() {
        this.killWaitingVerification.next();
    }

    setIneligibleClient(ineligibility: boolean) {
        this.ineligibleClient.next(ineligibility);
    }

    getIneligibleClient() {
        return this.ineligibleClient.value;
    }

    setConfirmationContactResponse(contactResponse: ConfirmationContactResponse) {
        this.confirmationContactResponseSubject.next(contactResponse);
    }

    getConfirmationContactResponse() {
        return this.confirmationContactResponseSubject.value;
    }

    setSelectedComponent(selectedComponent: string) {
        this.selectedComponentSubject.next(selectedComponent);
    }

    getSelectedComponent() {
        return this.selectedComponentSubject.asObservable();
    }

    setContactResponse(contactType: AgreementContactResponse) {
        this.contactResponse.next(contactType);
    }

    getContactResponse() {
        return this.contactResponse.value;
    }

    setBottomBar(isPage: boolean) {
        this.showBottomBar.next(isPage);
    }

    getBottomBarValue() {
        return this.showBottomBar.value;
    }

    setAccount(account: string) {
        this.accountId.next(account);
    }

    getAccount() {
        return this.accountId.value;
    }

    setPaymentAgreementTerm(payment: PaymentAgreement) {
        this.paymentAgreementTerm.next(payment);
    }

    getPaymentAgreementTerm() {
        return this.paymentAgreementTerm.value;
    }

    getDetailsData(id: string) {
        return this.apiService.callServicePostToCollection(`paymentAgreement.getDetailsData`, {
            id,
        });
    }

    errorProccessSetStatus(error: boolean) {
        this.errorProccessSubject.next(error);
    }

    errorProccessGetStatus() {
        return this.errorProccessSubject.value;
    }

    errorProccessSetToShow(status: boolean) {
        this.errorProccessToShowSubject.next(status);
    }

    errorProccessGetToShow() {
        return this.errorProccessToShowSubject.value;
    }

    setHeight(height: boolean) {
        this.heightSubject.next(height);
    }

    getHeight() {
        return this.heightSubject.asObservable();
    }
}
